import React from "react";
import { useTranslation } from "react-i18next";
import { getSchoolStateName } from "../../Constants/SchoolReturnState";

import "./SchoolStatusCell.scss";

export function SchoolStatusCell({ status }) {
  const [t] = useTranslation();

  const stateName = getSchoolStateName(status);
  
  return (
    <div className={`school-status-cell ${stateName}`} title={t(stateName)}>
      {t(stateName)}
    </div>
  );
}
